import initialState from './initialState';
import { reducer as saveTokenFromOrganizationReducer } from './saveTokenFromOrganization';
import { reducer as loadProjectDetailReducer } from './loadProjectDetail';
import { reducer as hideProjectWelcomePopupReducer } from './hideProjectWelcomePopup';
import { reducer as addLastAccessReducer } from './addLastAccess';

const reducers = [
  saveTokenFromOrganizationReducer,
  loadProjectDetailReducer,
  hideProjectWelcomePopupReducer,
  addLastAccessReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
